export default {
  components: {
    buttons: {
      createMaterial: 'Crear nuevo material',
      advancedSearch: 'Búsqueda avanzada',
    },
    tableRequestedMaterials: {
      id: 'Id',
      creationDate: 'Fecha Creación',
      name: 'Nombre Material',
      userCreate: 'Usuario Creación',
      area: 'Área',
      phase: 'Etapa',
      updateDate: 'Fecha Actualización',
      code: 'Código de ERP',
      statusPhase: 'Estado Etapa',
      integrationStatus: 'Estado Integración',
    },
    status: {
      white: 'Borrador',
      gray: 'Solicitud Cancelada',
      yellow: 'Solicitud en proceso',
      green: 'Solicitud Finalizada',
      red: 'Solicitud Rechazada',
      statusTitle: 'Etapa',
    },
    integrationStatus: {
      white: 'Borrador',
      yellow_integration_status: 'Pediente de integración',
      orange: 'Procesada',
      green: 'Recibida ok',
      blue: 'Integrado',
      red: 'Error en ERP',
    },
    advanceSearch: "Buscar...",
    editMatReq: "Editar solicitud",
    orgDiv: "División de la organización",
    all: "(Todas)",
    creationDialog: {
      title: "Crear nueva solicitud",
      confirmButton: "Crear",
      cancelButton: "Cancelar",
      parentArea: "Áreas Padre",
      area: "Área",
      selectParentArea: "Seleccione una área padre",
      selectArea: "Seleccione un área/centro",
    },
    rangeDates: {
      selectADay: "Seleccione un día",
      from: "Fecha inicio",
      to: "Fecha hasta",
      report: "Reporte",
      reporteGenericoWorkflow: "Reporte de solicitudes de creación",
      reporteExportarCollahuasi: "Exportar",
      reportAnalyst: "Reporte Analista",
      reporteCollahuasiEtapaAnalista: "Reporte de solicitudes etapa Analista",
      reportRejectOrAcceptDesc: "Reporte Aceptados o Rechazados",
      reporteCollahuasiRechazoAprobacion: "Reporte de solicitudes aprobadas o rechazadas",
      generateButton: "Generar Reporte",
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/cataloger/requestedMaterials/components.js